import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ComparatorOperators, CptCatalogueSortInput, CptQueryComplexInput, CreateQualitativeGQL, CreateQualitativeMutation, LegalEntityFields, LegalEntitySimpleQueryInput, OperatorInput, OrderTypeInput, QueryLegalEntitiesByQueryComplexArgs, RiskMapQualitativeByLegalEntityIdAndCampaignIdGQL, RiskMapQualitativeByLegalEntityIdAndCampaignIdQuery, UpdateQualitativeInputGQL, UpdateQualitativeInputMutation } from '../../../graphql/generated';
import { ENUM_CPT } from './riskmap.service';

@Injectable({
    providedIn: 'root'
})
export class QualitativeInputService {
    private readonly RiskMapQualitativeByLegalEntityIdAndCampaignIdGQL: RiskMapQualitativeByLegalEntityIdAndCampaignIdGQL = inject(RiskMapQualitativeByLegalEntityIdAndCampaignIdGQL);
    private readonly UpdateQualitativeInputGQL: UpdateQualitativeInputGQL = inject(UpdateQualitativeInputGQL);
    private readonly CreateQualitativeGQL: CreateQualitativeGQL = inject(CreateQualitativeGQL);

    getQualitative(legalEntityId: string, campaignId: string, params: any, completed?: boolean | null): Observable<RiskMapQualitativeByLegalEntityIdAndCampaignIdQuery['riskMapQualitativeByLegalEntityIdAndCampaignId']> {
        const param = params ? convertLazyLoadToComplexWithPageQualitativeInput(params) : null;

        return this.RiskMapQualitativeByLegalEntityIdAndCampaignIdGQL.fetch({ legalEntityId, campaignId, query: param?.query as CptQueryComplexInput || null, page: param?.page, sort: param?.sort as CptCatalogueSortInput || null, completed: completed }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data.riskMapQualitativeByLegalEntityIdAndCampaignId));
    }

    updateQualitative(questionId: string, id: string, comments: string, levelRelevanceId: string, opinionId: string): Observable<UpdateQualitativeInputMutation['updateQualitativeInputQuestion']> {
        return this.UpdateQualitativeInputGQL.mutate({
            comments: comments,
            questionId: questionId,
            id: id,
            opinionId: opinionId
        }).pipe(map(result => result.data!.updateQualitativeInputQuestion));

    }
    createQualitative(
        questionId: string,
        opinionId: string,
        legalEntityId: string,
        comments: string,
        campaignId: string,
        cptId: string
    ): Observable<CreateQualitativeMutation['createQualitativeInputQuestion']> {
        return this.CreateQualitativeGQL.mutate({
            questionId,
            campaignId,
            legalEntityId,
            opinionId,
            comments,
            cptId
        }).pipe(map(result => result.data!.createQualitativeInputQuestion));

    }
}



export function convertLazyLoadToComplexWithPageQualitativeInput(parameters: any): QueryLegalEntitiesByQueryComplexArgs {
    const query: LegalEntitySimpleQueryInput[] = [];
    if (parameters) {

        if (parameters.filters) {

            Object.entries(parameters.filters).forEach(([field, values]) => {
                //console.log"value", values);

                if (values !== null && Array.isArray(values) && values.length > 0) {
                    (ENUM_CPT[field as keyof typeof ENUM_CPT] || [field]).forEach(key => {
                        query.push({
                            field: key as LegalEntityFields,
                            filters: {
                                operator: ComparatorOperators.Match,
                                value: values
                            }
                        });
                    })
                }
            });
        }
    }
    return {
        query: {
            operator: OperatorInput.And,
            query: [
                {
                    query: query,
                    operator: OperatorInput.Or
                }
            ]
        },
        sort: {
            sortField: ENUM_CPT?.[parameters?.order?.sortField as keyof typeof ENUM_CPT]?.[0] as LegalEntityFields || null,
            sortOrder: parameters?.order?.sortDirection === 'ASC' ? OrderTypeInput.Asc : OrderTypeInput.Desc
        },
        page: {
            pageNo: parameters.page,
            pageSize: parameters.rows
        }
    }
}